import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { BrowserRouter as Router } from 'react-router-dom';
import LinearProgress from '@material-ui/core/LinearProgress';
import { connect } from 'react-redux';
import Sidebar from "./Sidebar/Sidebar";
import Content from "./Content/Content";
import InstanceLoading from "./InstanceLoading/InstanceLoading";
import MaintenanceRedirect from "./InstanceLoading/MaintenanceRedirect";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import LangIcon from '@material-ui/icons/Language';


const drawerWidth = 240;

const styles = theme => ({
    root: {
        display: 'flex',
    },
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    appBar: {
        marginLeft: drawerWidth,
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${drawerWidth}px)`,
        },
    },
    menuButton: {
        marginRight: 20,
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing.unit * 3,
    },
    rightToolbar: {
        marginLeft: 'auto',
        marginRight: -12,
    },
});

class App extends Component {
    state = {
        mobileOpen: false,
        anchorEl: null,
    };

    handleDrawerToggle = () => {
        this.setState(state => ({ mobileOpen: !state.mobileOpen }));
    };

    renderLoadingBar = () => {
        if (this.props.loading) {
            return <LinearProgress />;
        }
    };

    handleRightMenuClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    changeLang = (lang) => {
        // same language => do nothing
        if (localStorage.getItem('language') === lang) {
            return;
        }
        localStorage.setItem('language', lang);
        this.setState({ anchorEl: null });
        window.location.reload();
    };

    handleRightMenuClose = () => {
        this.setState({ anchorEl: null });
    };


    render() {
        const { classes, theme, instance, container } = this.props;
        const { anchorEl } = this.state;

        if (instance && instance.maintenanceRedirectUrl) {
            return <MaintenanceRedirect joinUrl={instance.maintenanceRedirectUrl} />;
        }

        if (!instance || !instance.data) {
            return <InstanceLoading instance={instance} />
        }

        return (
            <Router>
                <div className={classes.root}>
                    <CssBaseline />
                    <AppBar position="fixed" className={classes.appBar}>
                        <Toolbar>
                            <IconButton
                                color="inherit"
                                aria-label="Open drawer"
                                onClick={this.handleDrawerToggle}
                                className={classes.menuButton}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Typography variant="h6" color="inherit" noWrap>
                                {instance.data.name}
                            </Typography>

                            <section className={classes.rightToolbar}>
                                <IconButton
                                    aria-label="More"
                                    aria-owns={anchorEl ? 'long-menu' : undefined}
                                    aria-haspopup="true"
                                    onClick={this.handleRightMenuClick}
                                >
                                    <LangIcon />
                                </IconButton>
                                <Menu
                                    id="long-menu"
                                    onClose={this.handleRightMenuClose}
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl)}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                >
                                    <MenuItem key='spanishItem' onClick={() => this.changeLang('es')}>
                                        <span role="img" aria-label="Spanish">🇦🇷</span>Español
                                    </MenuItem>
                                    <MenuItem key='englishItem' onClick={() => this.changeLang('en')}>
                                        <span role="img" aria-label="English">🇺🇸</span>English
                                    </MenuItem>
                                </Menu>
                            </section>
                        </Toolbar>
                        {this.renderLoadingBar()}
                    </AppBar>
                    <nav className={classes.drawer}>
                        <Hidden smUp implementation="css">
                            <Drawer
                                container={container}
                                variant="temporary"
                                anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                                open={this.state.mobileOpen}
                                onClose={this.handleDrawerToggle}
                                classes={{
                                    paper: classes.drawerPaper,
                                }}
                            >
                                <Sidebar handleDrawerToggle={this.handleDrawerToggle} />
                            </Drawer>
                        </Hidden>
                        <Hidden xsDown implementation="css">
                            <Drawer
                                classes={{
                                    paper: classes.drawerPaper,
                                }}
                                variant="permanent"
                                open
                            >
                                <Sidebar />
                            </Drawer>
                        </Hidden>
                    </nav>
                    <main className={classes.content}>
                        <div className={classes.toolbar} />

                        <Content />

                    </main>
                </div>
            </Router>
        );
    }
}

App.propTypes = {
    classes: PropTypes.object.isRequired,
    container: PropTypes.object,
    theme: PropTypes.object.isRequired,
};

const AppStyle = withStyles(styles, { withTheme: true })(App);

const mapStateToProps = (state) => ({
    loading: state.loading,
    instance: state.instance,
});


export default connect(mapStateToProps, null)(AppStyle);
